


































import { Vue, Component } from 'vue-property-decorator';
import * as api from '@/api';

/**
 * rg操作记录
 *
 * @author liyuyao
 * @date 11/07/2019
 */
@Component
export default class RgTag extends Vue {
    searchTag: string = '';
    searchQuery: string = '';
    searchLoading: boolean = false;
    searchTagList: any = [];

    recommandTagList: any = [];
    rgId: number = 0;

    tagPermission: boolean = false;
    tagRequired: boolean = false;

    $mtd: any;

    get noMatchTag() {
        const ifMatch = this.searchTagList.find(tag => {
            return tag.name === this.searchQuery;
        });
        return this.searchQuery && !ifMatch;
    }

    mounted() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
        this.searchTagsByRg();
        this.getLabelPermission();
    }
    chooseTag(tagName) {
        if (!tagName) return;
        this.addRgTag(tagName);
    }
    createTag() {
        this.searchQuery && this.addRgTag(this.searchQuery);
    }
    async remoteMethod(query) {
        if (!query.length) return;
        this.searchLoading = true;
        try {
            const res = await api.ctiApi.searchTicketTags({
                name: query
            });
            this.searchQuery = query;
            this.searchTagList = res.data.items;
        } catch (e) {
            this.searchTagList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }

    async searchTagsByRg() {
        const res = await api.ctiApi.searchTagsByRg({
            rgId: this.rgId
        });
        const { code } = res;
        if (code === 200) {
            this.recommandTagList = res.data.items;
        }
    }
    async addRgTag(name: string) {
        const res = await api.ctiApi.addRgTag({
            rgId: this.rgId,
            name: name
        });
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success('常用标签添加成功');
            this.searchTag = '';
            this.searchTagsByRg();
        }
    }
    async deleteTag(tagId: number) {
        const res = await api.ctiApi.deleteRgTag(tagId, this.rgId);
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success('常用标签删除成功');
            this.searchTagsByRg();
        }
    }
    async setLabelPermission(val: boolean, type: string) {
        const isPermission = type === 'permission';
        const requestParam = isPermission
            ? {
                  labelSwitch: val
              }
            : {
                  labelRequired: val
              };
        const res = await api.rgApi.setLabelPermission({
            rgId: this.rgId,
            ...requestParam
        });
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success(isPermission ? '标签编辑权限设置成功' : '标签是否必填设置成功');
        }
        this.getLabelPermission();
    }
    async getLabelPermission() {
        const res = await api.rgApi.getLabelPermission({
            rgId: this.rgId
        });
        const { code, data } = res;
        if (code === 200) {
            this.tagPermission = data.labelSwitch;
            this.tagRequired = data.labelRequired;
        }
    }
}
